// Types
import {
  CrusherOperationalData,
  EquipmentUnitDataConeCrusher,
  TrendingType,
} from '../../../../../types/crusher';
import {
  EdgeDeviceOperationalStatus,
  EdgeDeviceOperationalStatusStatus,
} from '../../../../../types/global';

export interface TrendingsProps {
  alternativeTrending?: TrendingType;
  className?: string;
  idEquipmentUnit: string;
  onCloseTrendings: () => void;
  operationalData: CrusherOperationalData;
  showTrendings: boolean;
  testId?: string;
}

export enum TrendingStatistic {
  max = 'max',
  avg = 'avg',
  min = 'min',
}

export enum ChartMode {
  history = 'history',
  live = 'live',
  liveAggregate = 'live-aggregate',
}

export interface TrendingsChartData {
  timestamp: number;
  edgeStatus: number;
  hydraulicTrampPressure: number | null;
  hydraulicClampPressure: number | null;
  crusherMotorAmps: number | null;
  cavityLevel: number | null;
  lubricationSupplyTemperature: number | null;
  lubricationReturnTemperature: number | null;
  lubricationTankTemperature: number | null;
  lubricationOilPressure: number | null;
  vibrationSensor1: number | null;
  vibrationSensor2: number | null;
  vibrationSensor3: number | null;
  vibrationSensor4: number | null;
}

export type AggregateValue = { max?: number; avg?: number; min?: number };
export type SensorChartData = Omit<TrendingsChartData, 'edgeStatus'>;
export type CondensedHistoryItem = {
  timestamp: number;
  edgeStatus?: EdgeDeviceOperationalStatusStatus | number | null;
} & Record<string, number | AggregateValue | null>;
export type ChartItemTab = {
  key: TrendingType;
  label: string;
};

export type TrendingRawItem = (
  EquipmentUnitDataConeCrusher | EdgeDeviceOperationalStatus | CondensedHistoryItem
);

export type EdgeLike = { edgeStatus?: EdgeDeviceOperationalStatusStatus | number | null };

export interface ProcessedTrendingData {
  timestamp: number;
  edgeStatus?: EdgeDeviceOperationalStatusStatus | number | null;
  hydraulicTrampPressure?: number | AggregateValue | null;
  hydraulicClampPressure?: number | AggregateValue | null;
  crusherMotorAmps?: number | AggregateValue | null;
  cavityLevel?: number | AggregateValue | null;
  lubricationSupplyTemperature?: number | AggregateValue | null;
  lubricationReturnTemperature?: number | AggregateValue | null;
  lubricationTankTemperature?: number | AggregateValue | null;
  lubricationOilPressure?: number | AggregateValue | null;
  vibrationSensor1?: number | AggregateValue | null;
  vibrationSensor2?: number | AggregateValue | null;
  vibrationSensor3?: number | AggregateValue | null;
  vibrationSensor4?: number | AggregateValue | null;
}
